"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M4.44 20H11v-2H4.84zm13.92-6H13v2h5.76zM13 18v2h6.56l-.4-2zm-7.76-2H11v-2H5.64z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20 12H4L2 22h20zm-7 2h5.36l.4 2H13zm-2 6H4.44l.4-2H11zm0-4H5.24l.4-2H11zm2 4v-2h6.16l.4 2zM11 8h2v3h-2zm4.7647-.7949 1.4142-1.4142 2.1213 2.1213-1.4142 1.4142zm-11.0598.7077 2.1213-2.1213 1.4142 1.4142L6.1191 9.327zM3 2h3v2H3zm15 0h3v2h-3zm-6 5c2.76 0 5-2.24 5-5h-2c0 1.65-1.35 3-3 3S9 3.65 9 2H7c0 2.76 2.24 5 5 5"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M15 2c0 1.66-1.34 3-3 3S9 3.66 9 2z",
  opacity: ".3"
}, "2")], 'SolarPowerTwoTone');